module.exports = "<svg id=Layer_1 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 1024 1024\"><title>box</title><path d=M946.1,548.9v397H77.9V77.9H475.7V2H2V948.7A73.41,73.41,0,0,0,75.3,1022H1022V548.9Z /><path d=M622.8,4V79.7H891.7L605.4,366,659,419.6,944.9,133.7V402.4h75.7V77.1A73.06,73.06,0,0,0,947.5,4Z /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/mini-apps/app-switcher/icons/box.svg
// module id = 185
// module chunks = 0